(function(){
function ready(fn){
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
function setupKeepAsShownClean(){
var keepCard = document.getElementById('dlKeepCard');
var designWrap = document.getElementById('dlDesignWrap');
if (!keepCard || !designWrap) { setTimeout(setupKeepAsShownClean, 250); return; }
if (designWrap._dlKeepBound) return;
designWrap._dlKeepBound = true;
// Hidden color inputs we always want stripped under Keep-As-Shown, even if
// they happen to live outside dlDesignWrap on some product variants.
var COLOR_PROP_IDS = ['dlMainProp','dlSecondaryProp','dlAccentProp'];
function stripColorProps(){
for (var i = 0; i < COLOR_PROP_IDS.length; i++) {
var el = document.getElementById(COLOR_PROP_IDS[i]);
if (el) { el.disabled = true; el.value = ''; }
}
}
function syncKeep(){
var active = keepCard.classList.contains('selected');
designWrap.style.display = active ? 'none' : '';
var fields = designWrap.querySelectorAll('input, textarea, select');
for (var i = 0; i < fields.length; i++) {
if (fields[i].id !== 'dlKeepProp') fields[i].disabled = active;
}
if (active) stripColorProps();
// Always send explicit Yes/No so the order never shows blank for
// this field — staff can tell at a glance which way the customer went.
var keepProp = document.getElementById('dlKeepProp');
if (keepProp) {
keepProp.disabled = false;
keepProp.value = active ? 'Yes' : 'No';
}
}
syncKeep();
document.body.addEventListener('click', function(e){
if (e.target.closest && e.target.closest('#dlKeepCard')) {
setTimeout(syncKeep, 60);
}
});
// Safety net: right before submit, if Keep is selected, force-strip the
// color props one more time. Belt and suspenders.
var form = document.getElementById('dlForm');
if (form) {
form.addEventListener('submit', function(){
var active = keepCard.classList.contains('selected');
var keepProp = document.getElementById('dlKeepProp');
if (keepProp) {
keepProp.disabled = false;
keepProp.value = active ? 'Yes' : 'No';
}
if (active) stripColorProps();
}, true);
}
}
ready(setupKeepAsShownClean);
// Year / Make / Model required validation. Blocks submit in capture phase if
// any of the three bike fields is empty, highlights the missing one, and
// scrolls to it. Runs BEFORE the engine validator and cart submit.
function setupBikeRequired(){
var form = document.getElementById('dlForm');
var year = document.getElementById('dlYear');
var make = document.getElementById('dlMake');
var model = document.getElementById('dlModel');
if (!form || !year || !make || !model) { setTimeout(setupBikeRequired, 250); return; }
if (form._dlBikeReqBound) return;
form._dlBikeReqBound = true;
// HTML5 required on the underlying fields — gives native browser hints too.
try {
year.setAttribute('required', 'required');
make.setAttribute('required', 'required');
model.setAttribute('required', 'required');
} catch(_) {}
// Inject a visible "Required" tag next to the section title so customers
// see it upfront — same red pill style used elsewhere on the page.
try {
var section = year.closest && year.closest('.section');
var title = section && section.querySelector('.section-title');
if (title && !title.querySelector('.dl-required-injected')) {
var badge = document.createElement('span');
badge.className = 'required-tag dl-required-injected';
badge.textContent = 'Required';
badge.style.cssText = 'display:inline-block;margin-left:10px;padding:2px 9px;background:#d11919;color:#fff;border-radius:4px;font-size:11px;font-weight:700;letter-spacing:.5px;vertical-align:middle;text-transform:uppercase;';
title.appendChild(badge);
}
} catch(_) {}
function showBikeError(missing){
var existing = document.getElementById('dlBikeRequiredErr');
if (existing) existing.remove();
var anchor = (missing && missing[0]) || year;
var err = document.createElement('div');
err.id = 'dlBikeRequiredErr';
err.style.cssText = 'background:#fef2f2;border:1px solid #fca5a5;color:#991b1b;padding:10px 14px;border-radius:6px;margin-top:10px;font-size:13.5px;font-weight:600;';
var labels = missing.map(function(el){
if (el === year) return 'Year';
if (el === make) return 'Make';
if (el === model) return 'Model';
return '';
}).filter(Boolean);
err.innerHTML = '⚠️ Please fill in <strong>' + labels.join(', ') + '</strong> before adding to cart — we need to know which bike to cut your graphics for.';
anchor.parentNode.parentNode.appendChild(err);
for (var i = 0; i < missing.length; i++) {
missing[i].style.outline = '2px solid #d11919';
missing[i].style.outlineOffset = '2px';
missing[i].style.borderRadius = '4px';
}
anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
try { anchor.focus(); } catch(_) {}
}
function clearBikeError(){
var existing = document.getElementById('dlBikeRequiredErr');
if (existing) existing.remove();
[year, make, model].forEach(function(el){
el.style.outline = '';
el.style.outlineOffset = '';
});
}
form.addEventListener('submit', function(e){
var missing = [];
if (!(year.value || '').trim()) missing.push(year);
if (!(make.value || '').trim()) missing.push(make);
if (!(model.value || '').trim()) missing.push(model);
if (missing.length) {
e.stopImmediatePropagation();
e.preventDefault();
showBikeError(missing);
return false;
}
clearBikeError();
}, true);
[year, make, model].forEach(function(el){
el.addEventListener('change', function(){
if ((year.value || '').trim() && (make.value || '').trim() && (model.value || '').trim()) {
clearBikeError();
}
});
el.addEventListener('input', function(){
if ((year.value || '').trim() && (make.value || '').trim() && (model.value || '').trim()) {
clearBikeError();
}
});
});
}
ready(setupBikeRequired);
// Color defaults: on load, blank the pre-baked Black / CRF Red / White
// defaults on the Main / Secondary / Accent inputs (and their visible
// labels) so the order page never shows them unless the customer
// actively picked colors. When #dlChangeColors is unchecked, also
// disable the inputs so they don't submit at all.
function setupChangeColors(){
var checkbox = document.getElementById('dlChangeColors');
var mainProp = document.getElementById('dlMainProp');
var secondaryProp = document.getElementById('dlSecondaryProp');
var accentProp = document.getElementById('dlAccentProp');
if (!checkbox) { setTimeout(setupChangeColors, 250); return; }
if (checkbox._dlBoundCC) return;
checkbox._dlBoundCC = true;
// Clear pre-baked defaults so order page never shows preset colors
// unless the customer actively picked them.
if (mainProp) mainProp.value = '';
if (secondaryProp) secondaryProp.value = '';
if (accentProp) accentProp.value = '';
['dlNameMain','dlNameSecondary','dlNameAccent'].forEach(function(id){
var el = document.getElementById(id);
if (el) el.textContent = '—';
});
['dlPickMain','dlPickSecondary','dlPickAccent'].forEach(function(id){
var el = document.getElementById(id);
if (el) { el.style.background = '#f3f4f6'; el.style.border = '1px solid #d1d5db'; }
});
function sync(){
var on = checkbox.checked;
if (mainProp) mainProp.disabled = !on;
if (secondaryProp) secondaryProp.disabled = !on;
if (accentProp) accentProp.disabled = !on;
}
checkbox.addEventListener('change', sync);
sync();
// Belt and suspenders: at submit, if unchecked, force-disable + blank.
var form = document.getElementById('dlForm');
if (form) {
form.addEventListener('submit', function(){
if (!checkbox.checked) {
if (mainProp) { mainProp.disabled = true; mainProp.value = ''; }
if (secondaryProp) { secondaryProp.disabled = true; secondaryProp.value = ''; }
if (accentProp) { accentProp.disabled = true; accentProp.value = ''; }
}
}, true);
}
}
ready(setupChangeColors);
// Auto-detect bike size from Model input. Customers were leaving the
// default "Pit Bike / 50cc" pill selected even when their model was
// clearly a big bike (YZ450, 300 XC, KX250) or a mini bike (KX100),
// which forced staff to manually upgrade and charge the difference.
//
// Detection rules:
//   cc <= 50           → Pit Bike
//   65-110             → Mini Bike
//   200+               → Big Bike
//   125-150 ambiguous  → 4-stroke = Mini, 2-stroke = Big
//                        (TTR125/CRF150 are mini 4-strokes; YZ125/KX125 are big 2-strokes)
// Model-specific patterns handle irregular naming (CRF150R, KLX140 = mini).
function setupAutoBikeSize(){
var modelInput = document.getElementById('dlModel');
var sizeGroup = document.getElementById('dlSizeGroup');
var engineGroup = document.getElementById('dlEngineGroup');
var engineProp = document.getElementById('dlEngineProp');
if (!modelInput || !sizeGroup) { setTimeout(setupAutoBikeSize, 250); return; }
if (modelInput._dlAutoSizeBound) return;
modelInput._dlAutoSizeBound = true;

// Explicit mini-bike model patterns (small 4-stroke bikes commonly
// mis-detected by the number-only heuristic). Case insensitive, spaces
// and dashes ignored.
var MINI_MODELS = [
/^CRF(50|65|85)/,
/^CRF1(10|25|50|60|65|80|90)/, // CRF110F, CRF125F, CRF150R, CRF150F
/^CRF230/,
/^TTR(50|65|85|90|110|125|140)/,
/^KLX(65|85|110|140|150|230)/,
/^KX(65|85|100|112)/,
/^YZ(65|85)/,
/^RM(65|85|100)/,
/^JR(50|65|80)/, // Suzuki JR
/^DR-?Z(50|70|110|125)/,
/^PW(50|65|80)/, // Yamaha PW
/^TC(50|65|85|112)/, // Husky mini
/^(65|85|105|112)\s*(SX|TC|MC|XC)/, // KTM/Husky/GasGas 65/85 SX etc.
/^SX\s*(50|65|85|105|112)/,
/^MC\s*(50|65|85|105|112)/, // GasGas MC50/65/85
/^CX(50|65|85|112)/, // Cobra
/^50\s*(SX|TC|MC)/,
/^65\s*(SX|TC|MC)/,
/^85\s*(SX|TC|MC)/
];

// Explicit pit-bike patterns (50cc only)
var PIT_MODELS = [
/^CRF50/,
/^TTR50/,
/^JR50/,
/^DR-?Z50/,
/^PW50/,
/^TC50/,
/^SX\s*50/,
/^MC\s*50/,
/^CX50/,
/^(50|Z50|CT50)$/
];

function detectBikeSize(modelStr){
var m = String(modelStr || '').trim();
if (!m) return null;
var norm = m.toUpperCase().replace(/[\-_]+/g, '').replace(/\s+/g, ' ').trim();
var noSpace = norm.replace(/\s+/g, '');

// 1. Check pit-bike model patterns first
for (var i = 0; i < PIT_MODELS.length; i++) {
if (PIT_MODELS[i].test(noSpace) || PIT_MODELS[i].test(norm)) return 'pit';
}
// 2. Check mini-bike model patterns (catches CRF110/125/150, TTR125/140, KLX140/150, KX100, etc.)
for (var i = 0; i < MINI_MODELS.length; i++) {
if (MINI_MODELS[i].test(noSpace) || MINI_MODELS[i].test(norm)) return 'mini';
}
// 3. Fallback: extract largest plausible displacement number
var nums = norm.match(/\d+/g);
if (!nums) return null;
var cc = 0;
for (var i = 0; i < nums.length; i++) {
var n = parseInt(nums[i], 10);
// Displacements are 50–700cc; skip years (2020+), tiny suffix numbers, etc.
if (n >= 50 && n <= 700 && n > cc) cc = n;
}
if (cc === 0) return null;
if (cc <= 50) return 'pit';
if (cc <= 110) return 'mini';
if (cc >= 200) return 'big';
// 125-150 range is ambiguous — use engine type as tiebreaker.
var engine = (engineProp && engineProp.value) || '';
if (engine === '4-Stroke') return 'mini';
if (engine === '2-Stroke') return 'big';
return null; // wait for engine selection
}

function findPill(size){
var pills = sizeGroup.querySelectorAll('.pill');
var matcher;
if (size === 'pit') matcher = /pit/i;
else if (size === 'mini') matcher = /mini/i;
else if (size === 'big') matcher = /big/i;
else return null;
for (var i = 0; i < pills.length; i++) {
var val = (pills[i].dataset.value || pills[i].textContent || '');
if (matcher.test(val)) return pills[i];
}
return null;
}

function showAutoNotice(sizeLabel){
var notice = document.getElementById('dlSizeNotice');
if (!notice) return;
notice.innerHTML = '<span style="font-weight:700;">Bike size auto-set to ' + sizeLabel + '</span> based on your model. Tap a different option above if this isn’t right.';
notice.style.cssText = 'display:block;margin-top:8px;padding:8px 12px;background:#eff6ff;border:1px solid #93c5fd;color:#1e40af;border-radius:6px;font-size:13px;line-height:1.35;';
// Auto-fade after 6 seconds
clearTimeout(notice._dlHideTimer);
notice._dlHideTimer = setTimeout(function(){
notice.style.opacity = '0';
notice.style.transition = 'opacity .4s';
setTimeout(function(){ notice.style.display = 'none'; notice.style.opacity = ''; }, 400);
}, 6000);
}

function tryAutoSize(){
var size = detectBikeSize(modelInput.value);
if (!size) return;
var target = findPill(size);
if (!target) return;
if (target.classList.contains('selected')) return; // already right
var friendly = target.dataset.value || target.textContent || '';
// Trigger via .click() so the existing pill handler updates variant/price.
target.click();
showAutoNotice(friendly.replace(/\s*\$.*$/, '').trim());
}

// Bind: run auto-detect on model input, on engine change (for
// ambiguous 125/150), and on model blur.
modelInput.addEventListener('input', function(){
// small debounce so we don't fire on every keystroke
clearTimeout(modelInput._dlAutoTimer);
modelInput._dlAutoTimer = setTimeout(tryAutoSize, 350);
});
modelInput.addEventListener('change', tryAutoSize);
modelInput.addEventListener('blur', tryAutoSize);
if (engineGroup) {
engineGroup.addEventListener('click', function(){
setTimeout(tryAutoSize, 80);
});
}
// Run once at page load in case the model came prefilled (from
// a variant URL or restored state).
setTimeout(tryAutoSize, 400);
}
ready(setupAutoBikeSize);
// Two-choice UI at step 3: split the "Aftermarket Plastics?" step into
// a clear either/or decision at the top —
//   Box 1: "Graphic Kit Only" (customer already has plastics)
//   Box 2: "Add Plastic Kit + Free Install" (customer wants both)
// Selecting box 1 reveals the existing OEM / brand-picker / details.
// Selecting box 2 reveals the "Add a Set of Plastics" card (moved up
// from step 7) plus a link to the plastics catalog. Everything renders
// via JS injection so the section .liquid file needs no changes.
function setupPlasticsChoice(){
var oemCard = document.getElementById('dlOemCard');
var plasticsAddonCard = document.getElementById('dlPlasticsCard');
if (!oemCard || !plasticsAddonCard) { setTimeout(setupPlasticsChoice, 250); return; }
if (oemCard._dlChoiceBound) return;
oemCard._dlChoiceBound = true;
var step3Section = oemCard.closest('.section');
if (!step3Section) return;
var titleEl = step3Section.querySelector('.section-title');
var helpEl = step3Section.querySelector('.section-help');
// Update copy on the section header to match the new choice framing.
if (titleEl) titleEl.textContent = titleEl.textContent.replace(/Aftermarket Plastics\?/i, 'Plastics');
if (helpEl) helpEl.textContent = 'Select graphics only for your existing plastics, or add a complete plastics kit with complimentary installation.';
// Inject CSS for the two-box choice UI.
if (!document.getElementById('dlChoiceStyles')) {
var css = document.createElement('style');
css.id = 'dlChoiceStyles';
css.textContent = '' +
'#dl-root .dl-plastics-choice { display:grid; grid-template-columns:1fr 1fr; gap:12px; margin: 4px 0 14px; }' +
'@media (max-width:600px){ #dl-root .dl-plastics-choice { grid-template-columns:1fr; } }' +
'#dl-root .dl-choice-card { position:relative; cursor:pointer; padding:18px 18px 18px 52px; border-radius:10px; border:2px solid var(--line-strong,#d1d5db); background:#fff; transition:border-color .15s, box-shadow .15s, background .15s; }' +
'#dl-root .dl-choice-card:hover { border-color:#111; box-shadow:0 4px 14px rgba(0,0,0,0.06); }' +
'#dl-root .dl-choice-card.selected { border-color:#111; background:#fafaf7; box-shadow:0 6px 18px rgba(0,0,0,0.08); }' +
'#dl-root .dl-choice-card .dl-choice-check { position:absolute; top:18px; left:16px; width:24px; height:24px; border:2px solid var(--line-strong,#d1d5db); border-radius:50%; display:flex; align-items:center; justify-content:center; transition:border-color .15s, background .15s; }' +
'#dl-root .dl-choice-card.selected .dl-choice-check { border-color:#111; background:#111; }' +
'#dl-root .dl-choice-card.selected .dl-choice-check::after { content:""; width:9px; height:9px; border-radius:50%; background:#fff; }' +
'#dl-root .dl-choice-card h4 { margin:0 0 4px !important; font-size:16px !important; font-weight:800 !important; color:var(--ink,#111) !important; text-transform:uppercase !important; letter-spacing:.3px !important; line-height:1.2 !important; }' +
'#dl-root .dl-choice-card p { margin:0 !important; font-size:13px !important; color:var(--muted,#6b7280) !important; line-height:1.4 !important; }' +
'#dl-root .dl-choice-card .dl-badge-free { display:inline-block; margin-left:6px; padding:1px 7px; background:#d11919; color:#fff; font-size:10px; font-weight:800; border-radius:3px; text-transform:uppercase; letter-spacing:.5px; vertical-align:middle; }' +
'#dl-root .dl-plastics-link { margin-top:14px; padding:10px 14px; background:#f9fafb; border:1px solid #e5e7eb; border-radius:6px; text-align:center; }' +
'#dl-root .dl-plastics-link a { color:#111; font-size:13.5px; font-weight:700; text-decoration:underline; }' +
'#dl-root .dl-plastics-link a:hover { color:#d11919; }';
document.head.appendChild(css);
}
// Build the choice UI.
var choiceUI = document.createElement('div');
choiceUI.className = 'dl-plastics-choice';
choiceUI.id = 'dlPlasticsChoice';
choiceUI.innerHTML =
'<div class="dl-choice-card" data-choice="graphic">' +
'<div class="dl-choice-check"></div>' +
'<div class="dl-choice-content">' +
'<h4>Graphic Kit Only</h4>' +
'<p>Plastics on my bike are good — just send me the graphics kit sized to fit them.</p>' +
'</div>' +
'</div>' +
'<div class="dl-choice-card" data-choice="plastics">' +
'<div class="dl-choice-check"></div>' +
'<div class="dl-choice-content">' +
'<h4>Add Plastic Kit <span class="dl-badge-free">Free Install</span></h4>' +
'<p>Send me a full set of new plastics <em>and</em> graphics — with free graphic installation included.</p>' +
'</div>' +
'</div>';
// Insert the choice UI at the top of step 3, right after the help text.
var insertAnchor = helpEl && helpEl.nextSibling ? helpEl.nextSibling : oemCard;
step3Section.insertBefore(choiceUI, insertAnchor);
// Build the "Graphic Kit Only" content wrapper — everything after the
// choice UI that already lives in step 3 (OEM card, brand grid, details).
var pathGraphic = document.createElement('div');
pathGraphic.id = 'dlPathGraphicKit';
pathGraphic.style.display = 'none';
// Collect all siblings after the choice UI and move them into pathGraphic.
var toMove = [];
var cursor = choiceUI.nextSibling;
while (cursor) {
var next = cursor.nextSibling;
toMove.push(cursor);
cursor = next;
}
toMove.forEach(function(el){ pathGraphic.appendChild(el); });
step3Section.appendChild(pathGraphic);
// Build the "Add Plastic Kit" content wrapper. Move the existing
// dlPlasticsCard from step 7 into it so the customer sees the full
// add-a-plastics-kit UX right here.
var pathPlastics = document.createElement('div');
pathPlastics.id = 'dlPathAddPlastics';
pathPlastics.style.display = 'none';
var placeholder = document.createComment(' dlPlasticsCard originally here ');
plasticsAddonCard.parentNode.insertBefore(placeholder, plasticsAddonCard);
pathPlastics.appendChild(plasticsAddonCard);
plasticsAddonCard.style.display = '';
// "Plastics not shown?" link
var linkWrap = document.createElement('div');
linkWrap.className = 'dl-plastics-link';
linkWrap.innerHTML = '<a href="https://thedesignlabco.com/pages/plastics" target="_blank" rel="noopener">Don’t see your bike’s plastics? Browse our full catalog →</a>';
pathPlastics.appendChild(linkWrap);
step3Section.appendChild(pathPlastics);
// Click handler: switch active path + sync add-on selection state.
var cards = choiceUI.querySelectorAll('.dl-choice-card');
function selectChoice(choice){
for (var i = 0; i < cards.length; i++) {
if (cards[i].dataset.choice === choice) cards[i].classList.add('selected');
else cards[i].classList.remove('selected');
}
if (choice === 'graphic') {
pathGraphic.style.display = '';
pathPlastics.style.display = 'none';
// Deselect the plastics add-on so it never fires on this path.
if (plasticsAddonCard.classList.contains('selected')) {
plasticsAddonCard.classList.remove('selected');
}
var pp = document.getElementById('dlPlasticsProp');
if (pp) pp.value = '';
} else if (choice === 'plastics') {
pathGraphic.style.display = 'none';
pathPlastics.style.display = '';
// Auto-select the plastics add-on card so the order flags it.
if (!plasticsAddonCard.classList.contains('selected')) {
plasticsAddonCard.classList.add('selected');
}
var pp2 = document.getElementById('dlPlasticsProp');
if (pp2) pp2.value = 'Yes';
// Auto-check the free install bonus.
var fi = document.getElementById('dlFreeInstall');
if (fi && !fi.checked) fi.checked = true;
// On the graphic-only path we don't want plastics-type prop set —
// but on plastics-kit path we can label it clearly.
var typeProp = document.getElementById('dlPlasticsTypeProp');
if (typeProp) typeProp.value = 'New plastic kit (added)';
}
}
for (var i = 0; i < cards.length; i++) {
(function(card){
card.addEventListener('click', function(){ selectChoice(card.dataset.choice); });
})(cards[i]);
}
}
ready(setupPlasticsChoice);
// Series Logos picker — replaces the free-text input with three
// long banner cards (Supercross / Pro Motocross / Loretta Lynn's) plus
// an "Other" card that reveals a text input for anything else. The
// selected label is written to the existing properties[Series Logos]
// input so it lands on the order the same way it did before.
function setupSeriesLogosPicker(){
var input = document.querySelector('input[name="properties[Series Logos]"]');
if (!input) { setTimeout(setupSeriesLogosPicker, 250); return; }
if (input._dlSeriesBound) return;
input._dlSeriesBound = true;
var field = input.closest('.field') || input.parentNode;
var helpText = field && field.querySelector('.field-help');
var SERIES_OPTIONS = [
{ key: 'supercross', label: 'AMA Supercross', img: 'https://cdn.shopify.com/s/files/1/0758/0663/8402/files/Artboard_1SX.png?v=1783404142' },
{ key: 'promotocross', label: 'Pro Motocross', img: 'https://cdn.shopify.com/s/files/1/0758/0663/8402/files/Artboard_1_3x_4054677a-81c6-4b4b-a1cd-178dc3a7c9f6.png?v=1783404142' },
{ key: 'lorettalynns', label: "Loretta Lynn's Amateur National Championship", img: 'https://cdn.shopify.com/s/files/1/0758/0663/8402/files/Artboard_1LL.png?v=1783404142' }
];
// Convert the visible input to hidden — we still need it so its value
// gets picked up by the cart FormData submit.
input.type = 'hidden';
input.value = '';
// Update the field help copy for the new UI.
if (helpText) helpText.textContent = 'Pick a series banner for your number plates — or choose Other to type a series name we don’t list.';
// CSS for the picker.
if (!document.getElementById('dlSeriesStyles')) {
var css = document.createElement('style');
css.id = 'dlSeriesStyles';
css.textContent = '' +
'#dl-root .dl-series-picker { display:grid; grid-template-columns:1fr; gap:8px; margin-top:8px; }' +
'#dl-root .dl-series-card { position:relative; cursor:pointer; padding:0 0 0 44px; border-radius:8px; border:2px solid var(--line-strong,#d1d5db); background:#fff; transition:border-color .15s, box-shadow .15s; overflow:hidden; display:flex; align-items:stretch; min-height:56px; }' +
'#dl-root .dl-series-card:hover { border-color:#111; box-shadow:0 3px 12px rgba(0,0,0,0.06); }' +
'#dl-root .dl-series-card.selected { border-color:#111; box-shadow:0 4px 14px rgba(0,0,0,0.10); }' +
'#dl-root .dl-series-card img { flex:1 1 auto; width:100%; height:auto; max-height:74px; object-fit:cover; object-position:center; display:block; }' +
'#dl-root .dl-series-card .dl-series-check { position:absolute; top:50%; left:12px; transform:translateY(-50%); width:22px; height:22px; border:2px solid var(--line-strong,#d1d5db); border-radius:50%; background:#fff; z-index:2; display:flex; align-items:center; justify-content:center; transition:border-color .15s, background .15s; }' +
'#dl-root .dl-series-card.selected .dl-series-check { border-color:#111; background:#111; }' +
'#dl-root .dl-series-card.selected .dl-series-check::after { content:""; width:8px; height:8px; border-radius:50%; background:#fff; }' +
'#dl-root .dl-series-card.dl-series-other { padding:14px 14px 14px 44px; background:#fafafa; min-height:auto; }' +
'#dl-root .dl-series-card.dl-series-other span { font-weight:800; color:var(--ink,#111); font-size:14px; letter-spacing:.3px; text-transform:uppercase; }' +
'#dl-root #dlSeriesOtherWrap { margin-top:8px; display:none; }' +
'#dl-root #dlSeriesOtherWrap input { width:100%; padding:10px 12px; border:1.5px solid var(--line-strong,#d1d5db); border-radius:6px; font-size:14px; box-sizing:border-box; }' +
'#dl-root #dlSeriesOtherWrap input:focus { outline:none; border-color:#111; }';
document.head.appendChild(css);
}
// Build cards markup.
var container = document.createElement('div');
container.className = 'dl-series-picker';
container.id = 'dlSeriesPicker';
var html = '';
for (var i = 0; i < SERIES_OPTIONS.length; i++) {
var opt = SERIES_OPTIONS[i];
html += '<div class="dl-series-card" data-series="' + opt.key + '" data-label="' + opt.label + '">' +
'<div class="dl-series-check"></div>' +
'<img src="' + opt.img + '" alt="' + opt.label + '" loading="lazy" />' +
'</div>';
}
html += '<div class="dl-series-card dl-series-other" data-series="other" data-label="Other">' +
'<div class="dl-series-check"></div>' +
'<span>Other Series</span>' +
'</div>';
container.innerHTML = html;
// Text input revealed when "Other" is selected.
var otherWrap = document.createElement('div');
otherWrap.id = 'dlSeriesOtherWrap';
otherWrap.innerHTML = '<input type="text" id="dlSeriesOtherInput" placeholder="Type your series (e.g. GNCC, WORCS, JS7 Freestone)" />';
// Small "Clear selection" link that only shows when a card is selected.
var clearWrap = document.createElement('div');
clearWrap.id = 'dlSeriesClearWrap';
clearWrap.style.cssText = 'display:none;margin-top:6px;text-align:right;';
clearWrap.innerHTML = '<a href="#" id="dlSeriesClearLink" style="font-size:12px;color:var(--muted,#6b7280);text-decoration:underline;cursor:pointer;">× Clear selection</a>';
// Insert all three before the (now hidden) original input.
input.parentNode.insertBefore(container, input);
input.parentNode.insertBefore(otherWrap, input);
input.parentNode.insertBefore(clearWrap, input);
var cards = container.querySelectorAll('.dl-series-card');
var otherInput = otherWrap.querySelector('#dlSeriesOtherInput');
var clearLink = clearWrap.querySelector('#dlSeriesClearLink');
function clearAll(){
for (var j = 0; j < cards.length; j++) cards[j].classList.remove('selected');
otherWrap.style.display = 'none';
clearWrap.style.display = 'none';
input.value = '';
}
function selectCard(card){
// Toggle-off: clicking the already-selected card clears the picker.
if (card.classList.contains('selected')) { clearAll(); return; }
for (var j = 0; j < cards.length; j++) cards[j].classList.remove('selected');
card.classList.add('selected');
clearWrap.style.display = 'block';
var series = card.dataset.series;
if (series === 'other') {
otherWrap.style.display = 'block';
input.value = otherInput.value || '';
try { otherInput.focus(); } catch(_){}
} else {
otherWrap.style.display = 'none';
input.value = card.dataset.label || '';
}
}
for (var i = 0; i < cards.length; i++) {
(function(card){ card.addEventListener('click', function(){ selectCard(card); }); })(cards[i]);
}
otherInput.addEventListener('input', function(){ input.value = otherInput.value; });
otherInput.addEventListener('change', function(){ input.value = otherInput.value; });
clearLink.addEventListener('click', function(e){ e.preventDefault(); clearAll(); });
}
ready(setupSeriesLogosPicker);
})();
